<svg *ngIf="name">
  <svg:use [attr.xlink:href]="'#' + getSymbolId()"></svg:use>
</svg>
<div *ngIf="svgContent" class="svg-content" [innerHTML]="svgContent | skySafeHtml"></div>
